import { useMemo } from 'preact/hooks';
import { Fragment } from 'preact/jsx-runtime';

import { Icon24Cancel } from '@vkontakte/icons';
import { Header, Separator } from '@vkontakte/vkui';

import { useWidget } from '../../context/WidgetContext';
import { getWidgetLogoByTheme } from '../../utils';

import styles from './styles.module.css';

interface Props {
  logoSrc?: string;
  title?: string;
  onClose?: () => void;
}

export const WidgetHeader = ({ logoSrc, title, onClose }: Props) => {
  const { widgetTheme } = useWidget();

  const headerIcon = useMemo(() => {
    if (logoSrc) {
      return <img src={logoSrc} width={28} height={28} alt={title} />;
    }

    return getWidgetLogoByTheme(widgetTheme);
  }, [logoSrc, title, widgetTheme]);

  return (
    <Fragment>
      <Header
        className={styles.header}
        size="xl"
        before={headerIcon}
        after={<Icon24Cancel className={styles.closeButton} onClick={onClose} />}
      >
        {title}
      </Header>
      <Separator size={4} />
    </Fragment>
  );
};
